import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import SelectFild from '../../../../../components/SelectFild/SelectFild';
import Loader from '../../../../../components/Loader/Loader';
import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';

const RunwayRelated = ({ details, selectedCheckboxes, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const initialValues = {
        id: '',
        incidentType: "",
        location: "",
        aircraftOrVehicle: "",
        atcClearance: "",
        obstaclePresent: "",
        operationalDisruption: "",
        uploadedFiles: [],
    };

    useEffect(() => {
        if (details?.what_occurred?.details?.["7"]?.[0]) {
            const detailItem = details.what_occurred.details["7"][0];
            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};

            setPreImg(detailItem.image_json);

            formik.setValues({
                id: detailItem.id || '',
                incidentType: parsedData.incidentType || '',
                location: parsedData.location || '',
                aircraftOrVehicle: parsedData.aircraftOrVehicle || '',
                atcClearance: parsedData.atcClearance || '',
                obstaclePresent: parsedData.obstaclePresent || '',
                operationalDisruption: parsedData.operationalDisruption || '',
            });
        }
    }, []);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const selectedCatList = JSON.stringify(selectedCheckboxes);
            let param = {
                "aircraftOrVehicle": values.aircraftOrVehicle,
                "atcClearance": values.atcClearance,
                "incidentType": values.incidentType,
                "location": values.location,
                "obstaclePresent": values.obstaclePresent,
                "operationalDisruption": values.operationalDisruption
            };

            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["7"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 7;
            const sub_category = selectedCheckboxes["7"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));

            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });


            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;
    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="GroupList fieldset">
                        <div className='toggle-button'>
                            <h2 className="listTitle">
                                Runway / Taxiway / Operational Incidents
                            </h2>
                            <div className="btnColaps">
                                <FaChevronUp />
                            </div>
                        </div>

                        <div className="subFilds">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Incident Type</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="incidentType"
                                            value={values.incidentType}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Location (Runway/Taxiway)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="location"
                                            value={values.location}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Aircraft/Vehicle Involved</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="aircraftOrVehicle"
                                            value={values.aircraftOrVehicle}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>ATC Clearance (if relevant)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="atcClearance"
                                            value={values.atcClearance}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Obstacle/Hazard Present?</label>
                                        <SelectFild
                                            Firstop="Select Obstacle/Hazard Present?"
                                            selectName='obstaclePresent'
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.obstaclePresent}
                                            onChange={(selectedOption) => setFieldValue("obstaclePresent", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Operational Disruption</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="operationalDisruption"
                                            value={values.operationalDisruption}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <UploadWithSignature onFilesChange={setUploadedFiles} />

                            <div className='previewsimges'>
                                {preImg.map((fileUrl, index) => {
                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div key={index} className='imageboxs'>
                                                <div className='imgs pdfs'>
                                                    <div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                        </div>
                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs'>
                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="button-boxs grid pt-2 pb-2">
                                <button type="submit" className="btn btn-orange">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default RunwayRelated